import { Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EGAccordionSingle } from "../../../../MainComponents/Accordion/EGAccordion/EGAccordion";
import { InvolvedView } from "./InvolvedView";

export const InvolvedTypes = ({
  involvedsInInvestigation,
  involvedsInReport,
  setSelectedInvolved,
  setShowDrawer,
  handleSaveInvolveds,
  justView,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  return (
    <Stack spacing={2} padding={justView ? 0 : 2}>
      <Type
        title={t("involved.victims")}
        color={theme.palette.blue.main}
        kind="victim"
        involvedsList={involvedsInInvestigation?.victim || []}
        involvedsInReport={involvedsInReport?.victim || []}
        allInvolveds={involvedsInInvestigation}
        setSelectedInvolved={setSelectedInvolved}
        setShowDrawer={setShowDrawer}
        handleSaveInvolveds={handleSaveInvolveds}
        justView={justView}
      />
      {/* Accomplices comentado temporalmente */}
      {/* <Type
        title={t("involved.accomplices")}
        color={theme.palette.blueGray600.main}
        kind="accomplice"
        involvedsList={involvedsInInvestigation?.accomplice || []}
        involvedsInReport={involvedsInReport?.accomplice || []}
        allInvolveds={involvedsInInvestigation}
        setSelectedInvolved={setSelectedInvolved}
        setShowDrawer={setShowDrawer}
        handleSaveInvolveds={handleSaveInvolveds}
        justView={justView}
      /> */}
      <Type
        title={t("involved.offenders")}
        color={theme.palette.red.main}
        kind="offender"
        involvedsList={involvedsInInvestigation?.offender || []}
        involvedsInReport={involvedsInReport?.offender || []}
        allInvolveds={involvedsInInvestigation}
        setSelectedInvolved={setSelectedInvolved}
        setShowDrawer={setShowDrawer}
        handleSaveInvolveds={handleSaveInvolveds}
        justView={justView}
      />
      <Type
        title={t("involved.witnesses")}
        color={theme.palette.green.main}
        kind="witness"
        involvedsList={involvedsInInvestigation?.witness || []}
        involvedsInReport={involvedsInReport?.witness || []}
        allInvolveds={involvedsInInvestigation}
        setSelectedInvolved={setSelectedInvolved}
        setShowDrawer={setShowDrawer}
        handleSaveInvolveds={handleSaveInvolveds}
        justView={justView}
      />
    </Stack>
  )
}

const Type = ({
  title,
  color,
  kind,
  involvedsList,
  involvedsInReport,
  allInvolveds,
  setSelectedInvolved,
  setShowDrawer,
  handleSaveInvolveds,
  justView,
}) => {

  const theme = useTheme();

  const hasInvolved = involvedsList.length > 0 || involvedsInReport?.length > 0;
  if (!hasInvolved) return <></>;

  return (
    <EGAccordionSingle
      title={title}
      color={theme.palette.white.main}
      bgColor={color}
    >
      <Stack spacing={2}>
        {
          involvedsInReport?.map((item, idx) => (
            <InvolvedView
              key={`involved-${title}-report-${idx}`}
              color={color}
              involved={item}
              setSelectedInvolved={setSelectedInvolved}
              setShowDrawer={setShowDrawer}
              justView={justView}
            />
          ))
        }
        {
          involvedsList.map((item, idx) => (
            <InvolvedView
              key={`involved-${title}-investigation-${idx}`}
              index={idx}
              kind={kind}
              color={color}
              involved={item}
              allInvolveds={allInvolveds}
              setSelectedInvolved={setSelectedInvolved}
              setShowDrawer={setShowDrawer}
              handleSaveInvolveds={handleSaveInvolveds}
              justView={justView}
              hide={item.added}
            />
          ))
        }
      </Stack>
    </EGAccordionSingle>
  )
}